import{isObjectLike as t}from"./isObjectLike.js";import{isPlainObject as e}from"./isPlainObject.js";function n(i){return t(i)&&i.nodeType===1&&!e(i)}export{n as isElement};
